<template>
	<el-drawer title="编辑发票" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="400px"
		@close="close">
		<div class="drawer-content">
			<el-form :model="formData" ref="formData" label-position="top" v-loading="dataLoading">
				<div class="color-info MB10" v-if="formData">
					将同时修改同一个订单服务费和票款，用户的开票信息<br>
					<p class="color-warning MT10">{{ formData.typeView }}：{{ formData.statusView }}</p>
				</div>
				<el-form-item prop="titleType" label="发票抬头类型：" :rules="[{ required: true, message: '请选择发票抬头类型' }]">
					<el-radio-group v-model="formData.titleType" @change="changeType">
						<el-radio :label="1">个人</el-radio>
						<el-radio :label="2">企业</el-radio>
					</el-radio-group>
				</el-form-item>
				<template v-if="formData.titleType == 2">
					<el-form-item prop="title" :rules="[{ required: true, message: '请输入发票抬头' }]">
						<span slot="label">发票抬头：</span>
						<el-select v-model="formData.title" filterable remote placeholder="请输入发票抬头"
							:remote-method="getCompanyList" :loading="userLoading" size="medium"
							@change="companyNameChange">
							<el-option v-for="item in companyTagList" :key="item.creditNno" :label="item.companyName"
								:value="item.companyName">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="taxNumber" :rules="[{ required: true, message: '请输入纳税人识别号' }]">
						<span slot="label">纳税人识别号：</span>
						<el-input v-model="formData.taxNumber" style="width: 100%;" size="medium"
							placeholder="请输入纳税人识别号"></el-input>
					</el-form-item>
				</template>
				<template v-if="formData.titleType == 1">
					<el-form-item prop="title" :rules="[{ required: true, message: '请输入个人真实姓名' }]">
						<span slot="label">个人真实姓名：</span>
						<el-input v-model="formData.title" style="width: 100%;" size="medium"
							placeholder="请输入个人真实姓名"></el-input>
					</el-form-item>
					<!-- 个人类型：身份证号（非必填），提交时对应字段为taxNumber -->
					<el-form-item prop="taxNumber">
						<span slot="label">身份证号：</span>
						<el-input v-model.trim="formData.taxNumber" style="width: 100%;" size="medium"
							placeholder="请输入身份证号（非必填）" maxlength="18"></el-input>
					</el-form-item>
				</template>
				<el-form-item prop="email" label="邮箱:"
					:rules="[{ required: true, message: '请输入邮箱' }, { type: 'email', message: '请输入正确的邮箱地址' }]">
					<el-input v-model.trim="formData.email" placeholder="请输入邮箱地址" maxlength="100" style="width: 100%;"
						size="medium"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">关闭</el-button>
			<el-button type="primary" @click="submitForm()" :loading="btnLoading">确认创建</el-button>
		</div>
	</el-drawer>
</template>
<script>

const defaultFormData = {
	id: '',
	email: '',
	orderSn: '',
	taxNumber: '',
	title: '',
	titleType: 1,
}
export default {
	data() {
		return {
			drawerShow: false,
			btnLoading: false,
			formData: { ...defaultFormData },
			dataLoading: false,
			data: {},
			companyTagList: [],
			userLoading: false
		}
	},
	methods: {
		show(data) {
			this.formData = data ? {
				...defaultFormData,
				...data,
				titleType: data.titleType === '个人' ? 1 : 2
			}
				: { ...defaultFormData };
			this.drawerShow = true;

		},
		close() {
			this.formData = { ...defaultFormData };
			this.drawerShow = false;
			this.companyTagList = []
		},
		changeType() {
			this.formData.email = '';
			this.formData.title = '';
			//切换抬头类型时清空身份证号/税号，避免脏数据
			this.formData.taxNumber = '';
		},
		//获取企业名称		
		async getCompanyList(query) {
			if (query !== "") {
				this.userLoading = true;
				const res = await this.$request({
					url: '/common/company/suggest',
					method: 'get',
					params: { keyword: query }
				}).finally(() => {
					this.userLoading = false;
				});
				const { state, result } = res.data;
				if (state == 1 && result) {
					this.companyTagList = result;
				}
			}
		},
		companyNameChange(selectedCompanyName) {
			const selectedCompany = this.companyTagList.find(item => item.companyName === selectedCompanyName);
			if (selectedCompany) {
				this.formData.taxNumber = selectedCompany.creditNno;
			} else {
				this.formData.taxNumber = '';
			}
		},
		//表单提交
		submitForm() {
			this.$refs["formData"].validate(async (valid) => {
				if (valid) {
					this.btnLoading = true;
					this.$request({
						url: "/invoice/record/save",
						method: "POST",
						data: {
							...this.formData
						},
					})
						.then((res) => {
							const { state, msg } = res.data;
							if (state == 1) {
								this.$emit('onUpdate');
								this.close();
							} else {
								this.$message.error(msg || "请求失败");
							}
						})
						.catch(() => {
							this.$message.error("请求错误");
						})
						.finally(() => {
							this.btnLoading = false;
						});
				} else {
					return false;
				}
			})
		}
	}
}
</script>
<style lang="scss" scoped></style>